import { Injectable, Component, NgModule } from '@angular/core';
import { HttpClientModule, HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";

import { Observable, Subject, BehaviorSubject, ReplaySubject } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/first';

import { config } from './remote_access_portal.config';
import { UserService } from './user/user.service';

declare var $: any;
declare var window: any;

@Injectable({
  providedIn: 'root',
})
export class LaravelApiService {

  private _user;
  private LogInAs : any;

  private _clientConfig = null;
  public _configSub?: Observable<any>;

  public config: any = {
    defaultLocale: "us",
    API_URL: "assets/api",
    LARAVEL_URL: "api/",
  };

  constructor(
    protected http: HttpClient,
    protected user: UserService/*,
    protected router: Router*/
  ) {
    this.user.getLoggedInAs().subscribe(user=>{
      this.LogInAs = user.id;
    });
  }

  ngOnDestroy() {
	}

  // Update the token. Used by UserService to refresh token
  public makeHttpOptionsWithHeaders(params?: any): any {
		let httpOptions = {
			headers: new HttpHeaders({
				'Authorization': 'Bearer ' + this.user.getToken(),
				'X-Login-As': this.LogInAs || '',
				'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
			})
		}

    return { headers: httpOptions.headers, params: params, responseType: 'json' };
  }

  // primary purpose: updating the XSRF token cookie
  getClientConfig(forceRequest: boolean = false): ReplaySubject<any>  {
    window.laravelApis = window.laravelApis || []; window.laravelApis.push(this);// XXX
    const sub = new ReplaySubject(1);

    if (this._clientConfig && !forceRequest) {
      sub.next(this._clientConfig);
    } else if (this._configSub) { // to avoid duplicate HTTP requests
      this._configSub.subscribe((data) => {
        sub.next(data);
      });
    } else {
      this._configSub = this.list('client/config');
      this._configSub.subscribe((data) => {
        if (data !== null) {
          this._clientConfig = data;
          sub.next(data);
        }
      });
    }

    return sub;
  }

  reload(): void {
    window.location.reload();
  }

  /**
   * Fetch a resource
   * @param type
   * @param id
   */
  public fetch(type: string, id): Observable<any> {
    id = id || '';
    let opts = '';
    if(id == '')
    type = type;
    else
    type = type+'/'+id;

    let headers = this.makeHttpOptionsWithHeaders();
    return this.http.get(this.getBaseUrl() + config.LARAVEL_URL + type, headers)
      .first()
      .map(this.extractData)
      .catch(this.handleError.bind(this));
  }

  /**
   * Show a list of resource
   * @param type
   */
  public list(type: string, params?: any): Observable<any> {
    if (this.user.tempOrgID) {
      if (!params) params = {};
      params.org_id = this.user.tempOrgID;
      params['ngsw-bypass'] = true;
    }

    let headers = this.makeHttpOptionsWithHeaders(params);
    return this.http.get(this.getBaseUrl() + config.LARAVEL_URL + type, headers)
      .first()
      .map(this.extractData)
      .catch(this.handleError.bind(this));
  }

  /**
   * Fetch a non-JSON resource
   * @param type
   * @param id
   */
  public fetch_resource(type: string, id): Observable<any> {
    id = id || '';
    let opts = '';
    if(id == '')
    type = type;
    else
    type = type+'/'+id;

    let headers = this.makeHttpOptionsWithHeaders();
    headers.responseType = 'text';
    return this.http.get(this.getBaseUrl() + config.LARAVEL_URL + type, headers)
      .first()
      .map(this.extractData)
      .catch(this.handleError.bind(this));
  }

  /**
   * Create a new resource
   * @param type
   * @param data
   */
  public create(type: string, data): Observable<any> {
    return this.http.post(this.getBaseUrl() + config.LARAVEL_URL + type, data, this.makeHttpOptionsWithHeaders())
      .first()
      .map(this.extractData)
      .catch(this.handleError.bind(this));
  }

  public liveCreate(type: string, data) {
    return this.http.post(this.getBaseUrl() + config.LARAVEL_URL + type, data, this.makeHttpOptionsWithHeaders())
      .first()
      .map(this.extractData)
      .catch(this.handleError.bind(this));
  }

  /**
   * Update a new resource
   * @param type
   * @param id
   * @param data
   */
  public update(type: string, id, data): Observable<any> {
      return this.http.put(this.getBaseUrl() + config.LARAVEL_URL + type +'/'+ id, data, this.makeHttpOptionsWithHeaders())
        .first()
        .map(this.extractData)
        .catch(this.handleError.bind(this))
  }

  public post(type: string, data): Observable<any> {
    return this.http.post(this.getBaseUrl() + config.LARAVEL_URL + type, data, this.makeHttpOptionsWithHeaders())
    .first()
    .map(this.extractData)
    .catch(this.handleError.bind(this))
  }

  public put(type, data): Observable<any> {
    return this.http.put(this.getBaseUrl() + config.LARAVEL_URL + type, data, this.makeHttpOptionsWithHeaders())
      .first()
      .map(this.extractData)
      .catch(this.handleError.bind(this))
  }

  /**
   * Delete an existing resource
   * @param type
   * @param id
   */
  public delete(type: string, id): Observable<any> {
    return this.http.delete(this.getBaseUrl() + config.LARAVEL_URL + type +'/'+ id, this.makeHttpOptionsWithHeaders())
      .first()
      .map(this.extractData)
      .catch(this.handleError.bind(this));
  }

  /**
   * Delete several of an existing resource
   * @param type
   * @param ids
   *
   * NOTE: this routing is only implemented for /devices as of 2020-09-03T20:21:41Z
   * sending request as POST to type/delete/, to eaily transport JSON array of IDs
   */
  public deleteSeveral(type: string, ids:number[]): Observable<any> {
    return this.http.post(
      this.getBaseUrl() + config.LARAVEL_URL + type +'/delete/',
      { ids: ids },
      this.makeHttpOptionsWithHeaders()
    )
      .first()
      .catch(this.handleError.bind(this));
  }

  public liveDelete(type: string, id) {
    return this.http.delete(this.getBaseUrl() + config.LARAVEL_URL + type +'/'+ id, this.makeHttpOptionsWithHeaders())
      .first()
      .map(this.extractData)
      .catch(this.handleError.bind(this));
  }

  /**
   * Parse the data coming from an oberservable
   * @param body object
   */
  private extractData(body:any) {
    if (body) {
      return body.data || body;
    } else {
      return {};
    }
  }

  /**
   * Manage major error type
   * @param errmgs String
   */
  private majorError(errmgs) {
    console.log(errmgs);
  }

  /**
   * Handle error messages from an oberservable
   * @param response any
   */
  private handleError(response:any) {
    let errMsg = (response.message) ? response.message :
      response.status ? `${response.status} - ${response.statusText}` : 'Server error';

    //Handle bad request
    if (response.status == '403' || response.status == '400') {
      if (response.error =="token_invalid") {
        localStorage.removeItem('currentUser');
        // this.router.navigate(['/auth/login']);
      } 
    }

    if(response.status == '401') {
      this.user.refreshToken();
    }

    if(response.status == '500') {
      this.majorError(errMsg);
    }
    return errMsg;
  }

  /**
   * Get the base URL for the API endpoint
   */
  private getBaseUrl(){
    // return location.protocol + '//' + location.hostname + (location.port ? ':'+location.port : '') + '/';
    return '/'; // relative URI to enable automatic XSRF by Angular
  }

  protected http_get(path, params) {
    return this.http.get(this.getBaseUrl() + config.LARAVEL_URL + path, this.makeHttpOptionsWithHeaders(params))
      .first()
      .map(this.extractData)
      .catch(this.handleError.bind(this));
  }

}

